const accountsMenuItems = {
  items: [
    {
      id: 'admin-panel',
      title: 'ACCOUNTS',
      type: 'group',
      icon: 'icon-monitor',
      children: [
        {
          id: 'generate-invoice',
          title: 'Generate Invoice',
          type: 'item',
          icon: 'feather icon-list',
          url: '/accounts-portal/generate-invoice'
        },
        {
          id: 'invoice-overview',
          title: 'Invoice Overview',
          type: 'item',
          icon: 'feather icon-eye',
          url: '/accounts-portal/invoice-overview'
        },
        {
          id: 'components-on-hold',
          title: 'Components on Hold',
          type: 'item',
          icon: 'feather icon-list',
          url: '/accounts-portal/components-on-hold'
        }
      ]
    },
  ]
};

export default accountsMenuItems;